import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const ChartLoading = ({ height = 514 }) => {
  return (
    <Stack>
      <Skeleton
        variant="rounded"
        width={"100%"}
        height={height}
        sx={{ borderRadius: 5 }}
      />
    </Stack>
  );
};

export default ChartLoading;
